<template>
  <div class="peoplechoice">
    <Header :title="$t('m.TerminalMangermentList')"></Header>
    <div class="contentitem">
      <div class="content" style="padding-left: 10px;">
        <div class="top_bar">
          <div>
            <Cascader
              v-model="departmentValue"
              :data="departmentTreeList"
              @on-change="btnclick"
              style="width: 150px;margin-top: 0.08rem;"
              change-on-select
            ></Cascader>
          </div>

          <div>
            <Input
              class="inpu"
              prefix="ios-search"
              :placeholder="$t('m.PlsenterTermnal')"
              v-model="formItem.input"
              @on-enter="btnSearch"
              type="search"
            />
          </div>
        </div>

        <div>
          <Calendar
            ref="calendarChild"
            @childFn="parentFn"
            :loadInfo="loadInfo"
            :allTerminalsList="allTerminalsList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import Calendar from "./calendar";
import {
  getDepartmentsAndTerminals,
  getDepartmentsAndTersBySearch,
  getAllTerminals
} from "../../assets/js/url";

export default {
  name: "peoplechoice",
  data() {
    return {
      //当天选择的日期
      dataInfo: "",
      //初次加载部门的信息
      loadInfo: {}, //给日历组件
      split: 0.1,
      formItem: {
        input: ""
      },
      tb_data: [],
      departmentTreeList: [], //存储左侧部门树结构
      actionType: -1, //区分不同行为过来的
      meetname: "", //从汇控页面过来的，需要会议名称显示在导航条
      mcuId: "",
      cf_id: "",
      allTerminalsList: [], // 全部终端列表，给日历组件
      currentDepartmentId: "", //当前所在的部门id
      firstData: [],
      departmentValue: []
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    move() {
      return this.i % 4;
    }
  },
  mounted() {
    this.getAllTerminalsList();
    // this.getDepartmentsAndTerminals();
    //  window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize",this.detectOrient,false)
  },
  activated() {
    this.meetname = this.$route.query.meetname;
    this.getDepartmentsAndTerminals();
  },
  // deactivated () {
  //   this.$destroy(true)//销毁状态
  // },

  filters: {},
  components: {
    Header,
    Calendar
  },
  methods: {
    //    detectOrient(){
    //    if (window.orientation === 180 || window.orientation === 0) {
    //       console.log("这里是竖屏状态")
    //   }
    //   if (window.orientation === 90 || window.orientation === -90 ){
    //      console.log("这里是横屏状态")
    //       }
    // },
    tomeetact() {
      this.$router.push({
        path: "/meetingact",
        name: "meetingact",
        params: {
          cf_id: this.cf_id,
          mcuId: this.mcuId
        }
      });
    },
    parentFn(actionType, mcuId, cf_id) {
      this.actionType = actionType;
      this.mcuId = mcuId;
      this.cf_id = cf_id;
    },
    //点击左侧某个部门时重新拿到参数去加载日历
    btnclick(e, node) {
      let loadInfo = {};
      loadInfo.id = node[node.length - 1].id;
      // loadInfo.allTerIdList = node[node.length - 1].allTerIdList;
      loadInfo.meeting_vrmId = this.$route.params.meeting_vrmId;
      loadInfo.creatingTime = this.$route.params.creatingTime;
      loadInfo.allTerIdList = node[node.length - 1].terDirectList.map(item => {
        return item.id;
      }); //取得是此部门下所有终端id（仅点击的父级）
      // loadInfo.terAllList = node[node.length - 1].terAllList;
      loadInfo.terDirectList = node[node.length - 1].terDirectList;
      this.loadInfo = loadInfo;
      this.currentDepartmentId = node[node.length - 1].id;
      
      this.formItem = {input:''}
    },
    //请求左侧部门结构
    getDepartmentsAndTerminals() {
      this.$http
        .post(getDepartmentsAndTerminals, {
          useruuid: window.sessionStorage.getItem("UUID")
        })
        .then(
          res => {
            if (res.data.status === 2000) {
              //左侧树结构
              this.departmentTreeList = res.data.data;
              this.getTreeData(this.departmentTreeList); // 展示左边树需要改变返回的数据
              this.firstData = [this.departmentTreeList[0]]; //默认显示第一级部门的终端
              this.departmentValue = [this.firstData[0].id];
              this.btnclick("1", this.firstData);
            } else {
              this.$toast(res.data.data); //弹出错误信息
            }
          },
          err => {
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i]["label"] = data[i]["title"];
        data[i]["value"] = data[i]["id"];
        let children = data[i].children;
        if (children != null && children.length > 0) {
          this.getTreeData(children);
        }
      }
    },
    //获取全部终端列表
    getAllTerminalsList() {
      this.$http
        .post(getAllTerminals, {
          useruuid: window.sessionStorage.getItem("UUID"),
          time: this.dataInfo
        })
        .then(
          res => {
            if (res.data.status === 2000) {
              this.allTerminalsList = res.data.data;
              //提供加载日历的数据
              // this.setTerminalIds(this.allTerminalsList);
            } else {
              this.$toast(res.data.data); //弹出错误信息
            }
          },
          err => {
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },
    setTerminalIds(terminalsList) {
      let loadInfo = {};
      loadInfo.allTerIdList = [];
      for (let i = 0; i < terminalsList.length; i++) {
        loadInfo.allTerIdList.push(terminalsList[i]["id"]);
      }
      this.loadInfo = loadInfo;
    },
    rowClassName: function(row, index) {
      if (index % 2 == 0) {
        return "ivu-table-stripe-even";
      } else return "ivu-table-stripe-odd";
    },
    //搜索的时候
    btnSearch() {
      if (this.formItem.input == "") {
        //等于空时不是搜索状态
        this.getDepartmentsAndTerminals();
        // this.getAllTerminalsList();
      } else {
        //搜索时
        this.$http
          .post(getDepartmentsAndTersBySearch, {
            useruuid: window.sessionStorage.getItem("UUID"),
            departmentId: "", //this.currentDepartmentId 在当期部门下搜索，或者传“”表示在全局下搜索
            search: this.formItem.input
          })
          .then(res => {
            if (res.data.status === 2000) {
              // this.departmentTreeList = res.data.data.department;
              this.setTerminalIds(res.data.data.terminals);
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.top_bar {
  display: flex;
}
.backbtn {
  margin-top: 17px;
  margin-left: 25px;
}
.itemlist p {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
}

.itemlist p:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.1);
}

.right {
  float: right;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
  text-decoration: none !important;
}

.right img {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-left: 0.2rem;
}

.width {
  width: 49%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: underline;
  cursor: pointer;
}

.contentitm .title {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  color: #fff;
  font-size: 0.15rem;
  cursor: pointer;
}
.contentitem {
  /* width: 1366px; */
  width:auto
}
.contentitem .title img {
  height: 0.14rem;
  width: 0.14rem;
  vertical-align: middle;
  margin-top: -4px;
  margin-right: 5px;
}

.bottom {
  width: 120px;
  height: 35px;
  line-height: 35px;
  color: #fff;
  font-size: 0.14rem;
  text-align: center;
  border-radius: 5px;
  display: inline-block;
  cursor: pointer;
}
.inpu {
  margin-top: 0.08rem;
  margin-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/content/terminalcontrolPctest.vue